const ACTIVE_MODAL_SESSION_KEY = "active-modal-session";
const MODAL_SESSION_EVENT = "modal-session-change";

type ModalSessionListener = (activeId: string | null) => void;

const canUseWindow = () => typeof window !== "undefined";

export const getActiveModalSession = (): string | null => {
    if (!canUseWindow()) return null;

    try {
        return window.sessionStorage.getItem(ACTIVE_MODAL_SESSION_KEY);
    } catch {
        return null;
    }
};

const dispatchModalSessionChange = (activeId: string | null) => {
    if (!canUseWindow()) return;

    window.dispatchEvent(
        new CustomEvent(MODAL_SESSION_EVENT, {
            detail: { activeId },
        })
    );
};

export const acquireModalSession = (id: string) => {
    if (!canUseWindow()) return;

    try {
        window.sessionStorage.setItem(ACTIVE_MODAL_SESSION_KEY, id);
    } catch {
        return;
    }

    dispatchModalSessionChange(id);
};

export const releaseModalSession = (id: string) => {
    if (!canUseWindow()) return;

    const currentId = getActiveModalSession();
    if (currentId !== id) return;

    try {
        window.sessionStorage.removeItem(ACTIVE_MODAL_SESSION_KEY);
    } catch {
        return;
    }

    dispatchModalSessionChange(null);
};

export const subscribeModalSession = (listener: ModalSessionListener) => {
    if (!canUseWindow()) return () => { };

    const handler = (event: Event) => {
        const customEvent = event as CustomEvent<{ activeId?: string | null }>;
        const activeId = customEvent.detail?.activeId ?? getActiveModalSession();
        listener(activeId ?? null);
    };

    window.addEventListener(MODAL_SESSION_EVENT, handler as EventListener);

    return () => {
        window.removeEventListener(MODAL_SESSION_EVENT, handler as EventListener);
    };
};
